import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ServicesCTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-12 lg:py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`relative rounded-2xl overflow-hidden transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          style={{ minHeight: '220px' }}
        >
          <img
            src="https://public.readdy.ai/ai/img_res/8d41655d13c16ad9bf78be3bc4a97b74.jpg"
            alt="Contact CJ Solutions"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/75 to-slate-900/50"></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 px-8 py-12 lg:px-14 lg:py-14">
            <div className="text-center lg:text-left space-y-3 max-w-2xl">
              <span className="inline-block px-3 py-1 bg-amber-500/20 border border-amber-400/30 text-amber-400 text-xs font-semibold uppercase tracking-widest rounded">
                Ready to Get Started?
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Not Sure Which Service<br className="hidden sm:block" /> Is Right for You?
              </h2>
              <p className="text-white/70 text-base leading-relaxed">
                Our specialists are on hand to assess your needs and recommend the best path forward — with no obligation and full confidentiality.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row lg:flex-col gap-3 flex-shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-send-line text-lg"></i>
                </div>
                Contact Us Today
              </Link>
              <a
                href="https://wa.me/35795981879"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-white/10 hover:bg-white/20 border border-white/30 text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
